




















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class BurgerMenu extends Vue {
    public isOpen: boolean = false;

    @Prop(String)
    private homeLink!: string;

    public toggleBurgerMenu(): void {
        this.isOpen = !this.isOpen;
    }
}
